// 1_utils/expanded_toggle.js
// Exposes window.NAT.utils.expandedToggle(item): toggles the "expanded" class on
// the given element each time it is clicked.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.expandedToggle = function (item) {
	item.addEventListener("click", function () {
		item.classList.toggle("expanded");
	});
};
